export function restrictSpecialCharacters(inEvent) {
    // Get the key code
    let keycode = inEvent.which || inEvent.keyCode;
    
    // Check if key pressed is a special character
    if (
      keycode < 65 ||
      (keycode > 90 && keycode < 97) ||
      keycode > 122
    ) {
      // Restrict the special characters
      inEvent.preventDefault();
      return false;
    }
}